

import EditItem from 'features/shop-item/components/modal/edit-item';


export const ItemListEditView = () => {

    return (

        <>
            <EditItem />
        </>
    );
};
